/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The HubBoard component
 *
 * @author Thais Watanabe
 */
const HubBoard = (props) => {
  const {
    turbineInspection,
    inspectionModelItems,
    results,
    lastResults,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  // 9-2
  const i9_2 = inspectionModelItems.filter((obj) => obj.name === "9-2")?.[0];
  const r9_2 = results.filter((obj) => obj.itemId === "9-2")?.[0];
  const last_r9_2_1 = lastResults?.filter((obj) => obj.itemId === "9-2")?.[0];
  const last_r9_2_2 = lastResults?.filter((obj) => obj.itemId === "9-2")?.[1];

  return (
    <>
      <Card className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center" colSpan={19}>
                ピッチバッテリー電圧測定結果表
              </ColHeader>
            </tr>
            <tr>
              <ColHeader id="9-2" className="w-10 text-center print:hidden" rowSpan={2}>
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i9_2}
                  selectedResult={r9_2}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center">軸</ColHeader>
              <ColHeader className="text-center">今回 測定結果</ColHeader>
              <ColHeader className="text-center">
                {lastTurbineInspections?.[0]?.inspection.name}
              </ColHeader>
              <ColHeader className="text-center">
                {lastTurbineInspections?.[1]?.inspection.name}
              </ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">1</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r9_2?.childrenResults[19] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[19].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    r9_2?.childrenResults[19] ?? "-",
                    19
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_1?.childrenResults[19] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[19].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_1?.childrenResults[19] ?? "-",
                    19
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_2?.childrenResults[19] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[19].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_2?.childrenResults[19] ?? "-",
                    19
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">2</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r9_2?.childrenResults[20] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[20].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    r9_2?.childrenResults[20] ?? "-",
                    20
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_1?.childrenResults[20] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[20].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_1?.childrenResults[20] ?? "-",
                    20
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_2?.childrenResults[20] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[20].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_2?.childrenResults[20] ?? "-",
                    20
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">3</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r9_2?.childrenResults[21] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[21].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    r9_2?.childrenResults[21] ?? "-",
                    21
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_1?.childrenResults[21] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[21].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_1?.childrenResults[21] ?? "-",
                    21
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r9_2_2?.childrenResults[21] ?? "-"}
                  unit={i9_2?.inspectionModelItemChildren.items?.[21].unit}
                  isInputCorrect={isInputCorrect(
                    "9-2",
                    last_r9_2_2?.childrenResults[21] ?? "-",
                    21
                  )}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>
    </>
  );
};

export default HubBoard;
